export const dateToLocale = (value?: string) => {
  if (value) {
    const options: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'UTC',
    };

    const dateObject = new Date(value);

    if (!isNaN(dateObject.getTime())) {
      const dateFormatted = new Intl.DateTimeFormat('pt-BR', options).format(dateObject);
      return dateFormatted;
    } else {
      console.error('Invalid date string provided:', value);
    }
  }

  return new Date().toLocaleDateString('pt-BR');
};

export const isDateExpired = (datetimeToCheck: string) => {
  return new Date(datetimeToCheck) < new Date();
};

export const currencyToLocale = (value: number, showCents = true) => {
  if (isNaN(value)) return '';

  const options = {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: showCents ? 2 : 0,
  } as const;

  return value.toLocaleString('pt-BR', options);
};

const isClient = () => !!(typeof window !== 'undefined' && window.document && window.document.createElement);

export default function isMobile() {
  if (!isClient()) return;
  return !!window.matchMedia('screen and (max-width:767px)').matches;
}

export const filterValidItems = (items: { label: string; value: any; formatter?: (v: any) => any }[]) => {
  return items
    .filter(({ value }) => value !== 0 && value !== '' && value !== null && value !== undefined)
    .map(({ label, value, formatter }) => ({
      label,
      value: formatter ? formatter(value) : value,
    }));
};
